export const NEWPAY_MERCHANT = '12';

export const newpayVerify = (param?: string) => {
  if (param) {
    return `/${NEWPAY_MERCHANT}/verify/${param}` as const;
  }
  return 'verify/:id' as const;
};

export const newpayVerifySuccess = (param?: string) => {
  if (param) {
    return `/${NEWPAY_MERCHANT}/verify/success/${param}` as const;
  }
  return 'verify/success/:id' as const;
};

export const newpayVerifyFailed = (param?: string) => {
  if (param) {
    return `/${NEWPAY_MERCHANT}/verify/failed/${param}` as const;
  }
  return 'verify/failed/:id' as const;
};

export const newpayPay = (param?: string) => {
  if (param) {
    return `/${NEWPAY_MERCHANT}/pay/${param}`;
  }
  return 'pay/:id' as const;
};

export const newpayPaySuccess = (param?: string) => {
  if (param) {
    return `/${NEWPAY_MERCHANT}/pay/success/${param}` as const;
  }
  return 'pay/success/:id' as const;
};

export const newpayPayFailed = (param?: string) => {
  if (param) {
    return `/${NEWPAY_MERCHANT}/pay/failed/${param}` as const;
  }
  return 'pay/failed/:id' as const;
};

export const newpayPayProcessing = (param?: string) => {
  if (param) {
    return `/${NEWPAY_MERCHANT}/pay/processing/${param}` as const;
  }
  return 'pay/processing/:id' as const;
};
